import { oneOf, matching, nullableStr, type FieldCodec } from '../../lib/viewState';
import { BRANDS, SOCIAL_ASSET_CHANNELS, SOCIAL_ASSET_TYPES, type Brand, type SocialAssetType } from '../../../shared/types';
import { STATUS_FILTER_ORDER, type SocialFilters } from '../../lib/socialCalendar';

// ── Page ─────────────────────────────────────────────────────────────────

export const socialViewCodec = {
  view: oneOf('view', ['calendar', 'library'], 'library'),
  status: { param: 'status', def: 'ready', enc: value => value ?? 'all', dec: raw => raw === 'all' ? null : STATUS_FILTER_ORDER.includes(raw as NonNullable<SocialFilters['status']>) ? raw as SocialFilters['status'] : undefined } as FieldCodec<SocialFilters['status']>,
  brand: { ...nullableStr('brand'), dec: (raw: string) => BRANDS.includes(raw as Brand) ? raw as Brand : undefined } as FieldCodec<SocialFilters['brand']>,
  type: { ...nullableStr('type'), dec: (raw: string) => SOCIAL_ASSET_TYPES.includes(raw as SocialAssetType) ? raw as SocialAssetType : undefined } as FieldCodec<SocialFilters['type']>,
  month: matching('month', /^\d{4}-(0[1-9]|1[0-2])$/),
  channel: oneOf('channel', ['all', ...SOCIAL_ASSET_CHANNELS], 'all'),
};
